import { Button } from '@prishapolicy/shared/ui';

export const BlogBlueCard = (props: { label: string; title: string; insuranceType: string }) => {
  return (
    <div className="not-prose rounded-huge flex flex-col items-center justify-center bg-blue-400 p-10 text-center text-white">
      <p className="text-title-3 font-medium">{props.label}</p>
      <p className="text-title-3 pb-4 font-bold">{props.title}</p>
      <Button
        className="w-full"
        text={`Get ${props.insuranceType} Insurance`}
        theme="secondary"
        onClick={() => console.log('Button clicked')}
      />
    </div>
  );
};
